import { Link, useLocation } from "react-router-dom";
import { useI18n } from "@/i18n";
import DeployGuardBanner from "@/components/DeployGuard";

const TABS = [
  { to: "/admin", key: "nav_dashboard" },
  { to: "/admin/cards", key: "nav_cards" },
  { to: "/admin/users", key: "nav_users" },
  { to: "/admin/scheduler", key: "nav_scheduler" },
  { to: "/admin/billing", key: "nav_billing" },
  { to: "/admin/email", key: "nav_email" },
  { to: "/admin/media", key: "nav_media" },
];

export default function AdminNav() {
  const { t } = useI18n();
  const location = useLocation();
  return (
    <>
    <DeployGuardBanner />
    <nav className="mb-6 flex flex-wrap gap-1 border-b border-[#1F293D] pb-3" data-testid="admin-nav">
      {TABS.map((tab) => {
        const active = location.pathname === tab.to;
        return (
          <Link
            key={tab.to}
            to={tab.to}
            data-testid={`admin-tab-${tab.key}`}
            className={`rounded-md px-3 py-1.5 font-mono2 text-[11px] uppercase tracking-wider transition-colors ${
              active ? "bg-[#00FF87] text-[#07090E] font-bold" : "text-slate-400 hover:text-slate-100"
            }`}
          >
            {t(`admin.${tab.key}`)}
          </Link>
        );
      })}
    </nav>
    </>
  );
}
